"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"

const StyledContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: 48px;
  }
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: unset;
  }
`

const StyledNumber = styled(Typography)`
  margin: 0;
  color: ${sharedColors.brandDark};

  /* font-family: var(--rag); */
  height: fit-content;
  font-size: 64px !important;
  line-height: 72px !important;
  letter-spacing: 0;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 56px !important;
    line-height: 64px !important;
  }
`

export default function Statistics({ data }: { data: any }) {
  const itemsList = extractProperty(data, "itemsList") || []
  const items = itemsList.map((item: any) => {
    return {
      number: extractProperty(item, "number"),
      label: extractProperty(item, "label"),
    }
  }) as { number: string; label: string }[]
  return (
    <Container paddingMobile={true}>
      <StyledContainer>
        {items.map((el, i) => (
          <Item key={i}>
            <StyledNumber variant="h3">{el.number}</StyledNumber>
            <Typography variant="body1">{el.label}</Typography>
          </Item>
        ))}
      </StyledContainer>
    </Container>
  )
}
